import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "../../../styles/MBABatch.css";
import { getNISMDetailsList, saveNISMDetailsList } from "../../../services/getAllApi";


const NISMCertificationsTable = ({ students }) => {
  // const [students, setStudents] = useState([]); // Store student details
  const [formData, setFormData] = useState({}); // Store fee details

  // Fetch student data from backend
  const fetchNISMDetails = async () => {
    try {
      const nismresponse = await getNISMDetailsList();
      if (!nismresponse) {
        throw new Error("No NISM certification data received.");
      }
  
      const initialData = {};
  
      students.forEach((student) => {
        const nismCertifications = nismresponse.find((nismcertification) => nismcertification.student_id === student.id ) || {};
  
        initialData[student.id] = {
          nismEDC: nismCertifications.nismEDC || "",
          nismEDC_date: nismCertifications.nismEDC_date || "",
          nismEDC_status: nismCertifications.nismEDC_status || "Pending",
  
          nismCDC: nismCertifications.nismCDC || "",
          nismCDC_date: nismCertifications.nismCDC_date || "",
          nismCDC_status: nismCertifications.nismCDC_status || "Pending",
  
          nismFSM: nismCertifications.nismFSM || "",
          nismFSM_date: nismCertifications.nismFSM_date || "",
          nismFSM_status: nismCertifications.nismFSM_status || "Pending",
  
          nismRAC: nismCertifications.nismRAC || "",
          nismRAC_date: nismCertifications.nismRAC_date || "",
          nismRAC_status: nismCertifications.nismRAC_status || "Pending",
  
          nismMBC: nismCertifications.nismMBC || "",
          nismMBC_date: nismCertifications.nismMBC_date || "",
          nismMBC_status: nismCertifications.nismMBC_status || "Pending",
  
          nismAIFMC: nismCertifications.nismAIFMC || "",
          nismAIFMC_date: nismCertifications.nismAIFMC_date || "",
          nismAIFMC_status: nismCertifications.nismAIFMC_status || "Pending",
  
          nismFISC: nismCertifications.nismFISC || "",
          nismFISC_date: nismCertifications.nismFISC_date || "",
          nismFISC_status: nismCertifications.nismFISC_status || "Pending",
        };
      });
  
      setFormData(initialData);
    } catch (error) {
      console.error("Error fetching NISM details:", error);
    }
  };
  
  // Call fetchStudents inside useEffect
  useEffect(() => {
    fetchNISMDetails();
  }, [students]);



  // Handle input changes
  const handleChange = (e, studentId) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [studentId]: {
        ...formData[studentId],
        [name]: type === "checkbox" ? checked : value,
      },
    });
  };

  const handleSubmit = async () => {
    const nismDataArray = Object.keys(formData).map((mbaBatchId) => ({
      student_id: parseInt(mbaBatchId, 10),
      ...formData[mbaBatchId],
    }));

    console.log("Submitting Data:", JSON.stringify(nismDataArray, null, 2));

    try {
          await saveNISMDetailsList(nismDataArray);
          Swal.fire("Success", "Fees Data saved successfully!", "success");
          await fetchNISMDetails();
        } catch (error) {
          Swal.fire("Error", "Failed to save data", "error");
        }
  };

  return (
    <div>
      <button onClick={handleSubmit} className="handle-btn">
        <p className="button-save">Save Data</p>
      </button>
      <div className="table-container-MBA-Students-list">

        <table>
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Student ID</th>
              <th>Name</th>
              <th>Equity Derivatives</th>
              <th>Currency Derivatives</th>
              <th>Security Markets</th>
              <th>Research Analyst</th>
              <th>Merchant Banking</th>
              <th>Alt. Fund Manager</th>
              <th>Fixed Income</th>
            </tr>
          </thead>
          <tbody>
            {students.map((student, index) => (
              <tr key={student.id}>
                <td>{index + 1}</td>
                <td>{student.studentId}</td>
                <td>{student.name}</td>
                {[
                  { field: "nismEDC", dateField: "nismEDC_date", checkField: "nismEDC_status" },
                  { field: "nismCDC", dateField: "nismCDC_date", checkField: "nismCDC_status" },
                  { field: "nismFSM", dateField: "nismFSM_date", checkField: "nismFSM_status" },
                  { field: "nismRAC", dateField: "nismRAC_date", checkField: "nismRAC_status" },
                  { field: "nismMBC", dateField: "nismMBC_date", checkField: "nismMBC_status" },
                  { field: "nismAIFMC", dateField: "nismAIFMC_date", checkField: "nismAIFMC_status" },
                  { field: "nismFISC", dateField: "nismFISC_date", checkField: "nismFISC_status" },
                ].map((nismcertification, idx) => (
                  <td key={idx}>
                  <div style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "5px",
                      padding: "5px"
                    }}>
                    <input
                      type="number"
                      name={nismcertification.field}
                      value={formData[student.id]?.[nismcertification.field] || ""}
                      onChange={(e) => handleChange(e, student.id)}
                      style={{ width: "120px", textAlign: "center" }}
                    />
                    <input
                      type="date"
                      name={nismcertification.dateField}
                      value={formData[student.id]?.[nismcertification.dateField] || ""}
                      onChange={(e) => handleChange(e, student.id)}
                      style={{ width: "120px", textAlign: "center" }}
                    />
                    
                      <select
                      name={nismcertification.checkField}
                      value={formData[student.id]?.[nismcertification.checkField] || "Pending"}
                      onChange={(e) => handleChange(e, student.id)}
                      style={{
                        width: "120px",
                        textAlign: "center",
                        cursor: "pointer",
                        padding: "5px",
                        fontWeight: "bold",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        backgroundColor:
                          formData[student.id]?.[nismcertification.checkField] === "Completed"
                            ? "green"
                            : formData[student.id]?.[nismcertification.checkField] === "Ongoing"
                            ? "orange"
                            : "red",
                        color: "white",
                      }}
                    >
                      <option value="Pending" style={{ backgroundColor: "red", color: "white" }}>Pending</option>
                      <option value="Ongoing" style={{ backgroundColor: "orange", color: "white" }}>Ongoing</option>
                      <option value="Completed" style={{ backgroundColor: "green", color: "white" }}>Completed</option>
                    </select>
                  </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NISMCertificationsTable;
